/*
 *
 * ManageUserModal
 *
 * @version 1.0.0
 * @author Christopher Monti
 * @since 15-Jan-2025
 */

import ManageUserModal from './ManageUserModalContainer'

export default ManageUserModal
